import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { UserState } from 'src/app/states/user-state/user.state';
import { RightsService } from '../../../services/rights.service';
import { UnsavedChangesService } from '../../../services/unsavedChanges.service';
import { UserRoles } from '../../constants/userRoles';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public userName$: Observable<string> = inject(Store).select(UserState.getUserName);
  public userRole$: Observable<string> = inject(Store).select(UserState.getUserDetails);
  
  public title = 'Labconnector';
  public unassignedRole = UserRoles.roleUnassigned;

  public constructor(
    public accessService: RightsService,
    private authService: AuthService,
    private unsavedChangesService: UnsavedChangesService
  ) {}

  public logout(): void {
    if (this.unsavedChangesService.shouldContinue()) {
      this.unsavedChangesService.resetComponent();
      this.authService.logout();
    }
  }
}
